import {DataFetcher} from '@aboutyou/data-fetcher';

import React from 'react';
import {useHotProductSection} from '../useGetProductBulkSection';
import {HotProductBanner} from './Components/HotProductBanner';

export const HotProductSection: React.FC<React.PropsWithChildren> = props => {
  return (
    <DataFetcher
      request={useHotProductSection()}
      Error={null}
      Loading={undefined}
      View={HotProductBanner}
      viewProps={props}
    />
  );
};
